import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=01bfcc75&"
import script from "./Sync.vue?vue&type=script&lang=js&"
export * from "./Sync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/ligo/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01bfcc75')) {
      api.createRecord('01bfcc75', component.options)
    } else {
      api.reload('01bfcc75', component.options)
    }
    module.hot.accept("./Sync.vue?vue&type=template&id=01bfcc75&", function () {
      api.rerender('01bfcc75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/Sync.vue"
export default component.exports